import * as moment from 'moment';

import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AssociationService } from '../../../../../../../services/association/association.service';
import { CallbackResult, CallbackResultStatus, dateStringFromISO8601 } from '../../../../../../../utils';
import { AssociationMember } from '../../../../../../../models/association';
import { AccountService } from '../../../../../../../services/account/account.service';
import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';


@Component({
  selector: 'app-edit-association-for-customer-modal',
  templateUrl: './edit-association-for-customer-modal.component.html',
  styleUrls: ['./edit-association-for-customer-modal.component.css']
})
export class EditAssociationForCustomerModalComponent implements OnInit {

  @Input() associationMember: AssociationMember;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';
  public serverError: number = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public dateStringFromISO8601 = dateStringFromISO8601;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService,
    private associationService: AssociationService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }
  }

  public handleReverify() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.associationService
      .reverifyAssociationMember(this.associationMember.id)
      .then(() => {
        this.savedCallback({
          text: 'Association member successfully re-verified.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to re-verify this association member.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  public handleRemove() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.associationService
      .removeAssociationMember(this.associationMember.url)
      .then(() => {
        this.savedCallback({
          text: 'Customer successfully removed from association.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove this association member.';
        } else if (reason.status === 404) {
          this.errorMessage = 'This association member was not found. They may have been removed already.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  public getReverificationWindowStart() {
    return moment(this.associationMember.next_automatic_removal_datetime)
      .subtract(this.associationMember.association_reverification_period_days, 'days')
      .format('ll');
  }

}
